'use client';

import { ReactNode, useState } from 'react';
import { CheckIcon, CopyIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

import notify from '@/utils/shared/notify';

import { Button } from '../button';
import * as React from 'react';

type CopyButtonProps = {
  value: string;
  children: ReactNode;
} & React.ComponentProps<typeof Button>;

export function CopyButton({ value, children, ...rest }: CopyButtonProps) {
  const [copied, setCopied] = useState<boolean>(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);

      setCopied(true);

      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      notify.error('Kopiering av inbjudningslänk misslyckades');
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <Button onClick={handleCopy} aria-label={copied ? 'Copied' : 'Copy to clipboard'} disabled={copied} {...rest}>
      <div className="relative w-4 h-4">
        {/* Copy Icon (shown when idle) */}
        <CopyIcon
          data-slot="icon"
          className={cn('absolute transition-opacity duration-200', copied ? 'opacity-0' : 'opacity-100')}
          size={16}
          aria-hidden="true"
        />

        {/* Check Icon (shown when copied) */}
        <CheckIcon
          data-slot="icon"
          className={cn(
            'absolute transition-opacity duration-200 stroke-emerald-500',
            copied ? 'opacity-100' : 'opacity-0',
          )}
          size={16}
          aria-hidden="true"
        />
      </div>
      {children}
    </Button>
  );
}
